export const m = {
  EnterID: "Click to enter Tada ID",
  "select-specifications": "Click to select recharge specifications",
  "check-account": "Check the recharge account",
  whatID: "What is Tada ID?",
  getID: "Enter Tada ID",
  maskgetID: "Enter Tada ID",
  "toastTips-format-error": "Input format is incorrect",
  "toastTips-no-exist": "The ID does not exist",
  toastTipsPlease: "Please check the recharge account first",
  "common-problem": "Common problem",
  "transaction-succeeded": "Transaction succeeded",
  "transaction-failed": "Transaction failed",
  "transaction-cancel": "Transaction cancelled",
  "whether-account":
    "1. How to check whether the account is received after I recharge?",
  "answer-whether-account":
    "After recharging, you can return to the app's [My]-[Wallet] to view diamonds",
  "no-account": "2.What if I don't get the account after recharge?",
  "answer-no-account":
    "Please submit your questions in [Message]-[Official News]-[Feedback and Help] of the app, and provide the following information, our customer service will help you.",
  "recharge-money": "1. Recharge amount and account ID",
  "recharge-time": "2. Recharge time and date",
  "recharge-shot": "3. Screenshot of successful payment",
  "recharge-wrong":
    "3.What should I do if I charge the wrong account and the wrong amount",
  "answer-recharge-wrong":
    "Before entering the payment password, please make sure to carefully confirm the recharge account ID and recharge amount information to make a purchase. The amount of the wrong charge cannot be refunded. For the wrong charge account, you can try to contact the ID user who you actually recharged, and negotiate with the other party if they are willing to compensate your recharge",
  refund: "4.Refund",
  "answer-refund": "Sorry! Tada currently does not support any form of refund.",
  "buy-enter-link":
    'Purchase diamonds can be recharged through the link, <a class ="web-link" href = "http: //pay.tadachat.info/" >http://pay.tadachat.info</a> Copy the link in the mobile browser to open, enter the purchase page, after checking the account, select the corresponding specifications and use the appropriate payment method to pay~ Lots of discounts!',
  "buy-notice-a":
    "Not: <a>pay.tadachat.info</a> is the only official diamond purchase website for Tada",
  replace: "Change",
  sureBtn: "Confirm",
  "pay-style": "Choose payment method",
  goBack: "Back to the homepage",
  toastTips: "Enter Tada ID",
  rechargeFAQ_title: "Common problem",
  PayStatusSuccess_title: "Transaction succeeded",
  PayStatusFail_title: "Transaction failed",
  PayStatusCancel_title: "Transaction cancelled",
  Diamonds_title: "Tada Diamond Recharge Official Website",
  "buy-notice":
    "Note pay.Tadachat.info is Tada's only official diamond-purchasing website, For customer service inquiries, please enter [Message]-[Official News]-[Feedback and Help]",
  RechargeHelp_title: "Recharge help",
  openAPP: "Open Tada APP",
  "buy-diamonds-tit": "Purchasing Diamond Service",
  description:
    "Tada is the only official diamond recharge site, Tada is an international social software, there are more than 150 countries and regions around the world are using Tada",
  keywords:
    "Tada recharge, Tada diamond recharge, Tada official recharge, Tada official recharge website",
  payforType: "Recharge method",
  trueText: "Confirm",
  falseText: "Cancel",

  alertShowTxt1: "Are you sure to use",
  alertShowTxt3: "to recharge",
  alertShowTxt5: "diamonds?",

  EnterIDTip: "Tada quick recharge",

  scanLogin:
    "For account privacy and security, please scan the code to log in.",
  scanTip:
    'Ti: Click on the top right corner of the Tada "Personal Center/Dynamics" and "scan".Scan code login,and support the identification of two - dimensional code screenshots login.',
  scanVersion:
    "Please upgrade Tada to the %s version and scan the code to log in",
  delAccount: "Delete account",
  logout: "Sign out",

  submit: "Submit",
  email_place_holder: "Please enter your email address",
  contact_email: "Contact E-mail",
  provide_email: "Please provide your E-maii address for payment order",
  email_address: "E-mail Addrerss",
};



// WEBPACK FOOTER //
// ./src/lang/en.js